import React, { useEffect, useState } from "react";
import { client } from "../sanityClient";
import { Link } from "react-router-dom";
import { urlFor } from "../sanityClient";

const ProductCategory = () => {
    const [categories, setCategories] = useState([]);


    useEffect(() => {
        const fetchCategories = async () => {
            const query = `*[_type == "productCategory" && featured == true] | order(_createdAt desc) [0...6] { 
                _id, title, image 
            }`;

            try {
                const data = await client.fetch(query);
                setCategories(data);
            } catch (err) {
                console.error("Error fetching featured categories:", err);
            }
        };
        fetchCategories();
    }, []);

    return (
        <section className="container bg-[#33367b] mx-auto py-4 sm:py-16 px-4 rounded-3xl">
            {/* Tiêu đề & mô tả */}
            <div className="text-center mt-4 mb-12">
                <h2 className="mx-2 text-white text-3xl sm:text-4xl font-semibold leading-normal text-center">
                    Đa dạng chất liệu – Đáp ứng mọi nhu cầu thiết kế
                </h2>
                <p className="font-OpenSans font-normal text-base leading-relaxed text-gray-300 mt-2">
                    Khám phá các sản phẩm đa dạng của chúng tôi
                </p>
            </div>

            {/* Grid layout cho danh mục */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 gap-x-16 mx-4 sm:mx-0 md:mx-8 lg:mx-0 xl:mx-16">
                {categories.map((category) => (
                    <Link
                        key={category._id}
                        to={`/products?category=${category._id}`}
                        className="block text-center overflow-hidden transition-transform duration-300 hover:scale-[1.02]"
                    >
                        <img
                            src={urlFor(category.image).url()}
                            alt={category.title}
                            className="w-full h-72 2xl:h-96 object-cover border-2"
                        />
                        <div className="text-gray-200 py-3 text-[1rem] font-normal uppercase">
                            {category.title}
                        </div>
                    </Link>
                ))}
            </div>

            {/* Thêm phần "Khám phá các chất liệu vải khác" */}
            <div className="text-center mt-12">
                <h3 className="text-white text-xl sm:text-2xl font-semibold">
                    Khám phá các chất liệu vải khác
                </h3>
            </div>

            {/* 2 Nút CTA đứng cạnh nhau */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
                <Link
                    to="/products"
                    className="sm:w-fit w-full group px-3.5 py-2 bg-white transition-all duration-700 ease-in-out justify-center items-center flex"
                >
                    <span className="px-1.5 tracking-tight text-[#33367b] text-base  font-bold leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">
                        Xem bộ sưu tập
                    </span>
                    <svg
                        className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                    >
                        <path
                            d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996"
                            stroke="#33367b"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Link>

                <Link
                    to="/wishlist"
                    className="sm:w-fit w-full group px-3.5 py-2 bg-[#33367b] hover:bg-indigo-800 transition-all duration-700 ease-in-out justify-center items-center flex"
                >
                    <span className="px-1.5 tracking-tight text-white text-base  font-semibold leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">
                        Liên hệ
                    </span>
                    <svg
                        className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                    >
                        <path
                            d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996"
                            stroke="#FFFFFF"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Link>
            </div>
        </section>
    );
};

export default ProductCategory;
